import React from 'react'
import { Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import { Badge } from 'react-bootstrap'
import { OUR_USER } from '../../constants/configs'

const LotteryList = ({ lotteries }) => {
  return (
    <Row>
      {lotteries === undefined || lotteries.length === 0 ? (
        <Col className="my-3">ไม่พบข้อมูล</Col>
      ) : (
        lotteries?.map((lottery, i) => {
          const user = lottery?.user?.userId ? lottery.user : OUR_USER
          const province = user?.province
          const nickName = user?.nickName
          const phoneNumber = user?.phone
            ? lottery.user.phone.slice(0, 1) + 'XXXXXX' + lottery.user.phone.slice(-3)
            : OUR_USER.phone.slice(0, 1) + 'XXXXXX' + OUR_USER.phone.slice(-3)

          return (
            <Col sm={6} md={6} lg={4} xl={3} xxl={2} className="my-3" key={i}>
              <div className="py-1 d-flex justify-content-between">
                <span>{lottery.matrixId}</span>
                <span className="text-right">
                  {lottery.sourceBook || ''} / {lottery.sourceFile || ''}
                </span>
              </div>

              <ImageLotteries src={`${lottery.image.slice(0, -4)}_M.jpg`} />
              <Info>
                <RowInfo>
                  <div className="text-right">เบอร์โทรศัพท์</div>
                  <Badge variant="primary light">{phoneNumber}</Badge>
                </RowInfo>
                <RowInfo>
                  <div className="text-right">ชื่อเล่น</div>
                  <TextOverflow className="text-right">{nickName}</TextOverflow>
                </RowInfo>
                <RowInfo>
                  <div className="text-right">จังหวัด</div>
                  <div className="text-right">{province}</div>
                </RowInfo>
              </Info>
            </Col>
          )
        })
      )}
    </Row>
  )
}

export default LotteryList

const ImageLotteries = styled.img`
  width: 100%;
`

const Info = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const RowInfo = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const TextOverflow = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 20ch;
`
